export const appHeaderHeight = '66px'
export const appHeaderbannerHeight = '115px'
export const appSidebarWidth = '270px'
export const appSidebarItemTopPadding = '24px'
export const defaultHeaderFontSize = '20px'
export const pagePadding = '10px'
export const appLeftPadding = '10px'
export const sidebarLeftPadding = '20px'
export const appRightPadding = '30px'
export const appOutsideFontSize = '14px'
export const toastTop = '10px'
export const toastRight = appRightPadding
export const mainRoutePageWrapperPadding = '20px'
export const mainRouteTitleHeight = '60px'
